import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { FormControl } from '@material-ui/core';
import { TreeViewSelect, TreeViewSelectNode } from '../../../../TreeViewSelect';
import { FormFields } from '../styles';
import { AssignIdentityFormValues } from '../types';

interface AddRolesAndAttributesStepProps {
  control: Control<AssignIdentityFormValues>;
  items: TreeViewSelectNode[];
  disabled?: boolean;
}

export function AddRolesAndAttributesStep({
  control,
  items,
  disabled = false,
}: AddRolesAndAttributesStepProps) {
  return (
    <FormControl component="fieldset" style={{ width: '100%' }}>
      <FormFields>
        <Controller
          name="contents"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TreeViewSelect
              id="assign-identity-roles-and-attributes"
              items={items}
              value={field.value}
              onChange={field.onChange}
              label="Add roles and attributes"
              placeholder="Search roles and attributes..."
              required
              disabled={disabled}
              error={Boolean(error)}
              helperText={error?.message}
            />
          )}
        />
      </FormFields>
    </FormControl>
  );
}
